import React, {useContext, useEffect, useState,} from "react";
import {useLocation, useParams} from "react-router-dom";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import {Button} from "../ui/button";
import {useAuthInfo, } from "@propelauth/react";
import {Checkbox} from "@radix-ui/react-checkbox";
import {fetchWithToken, postWithToken} from "../../api/apiBase";
import {DirectoryEntry} from "../../models/permissions";
import {MultiSelectCombobox} from "../ui/comboBox";
import {UserContext} from "../../contexts/UserContext";

interface InviteBidderByEmailProps {
    onInvite: (email: string) => void;
    currentUsers: string[]
}

/*
* */
export default function InviteTeamMember(
    {
        onInvite,
        currentUsers,
        }: InviteBidderByEmailProps) {
    const {project_id} = useParams<string>();
    const {accessToken} = useAuthInfo()
    const userContext = useContext(UserContext);
    const [isEnabled, setIsEnabled] = useState<boolean>(false);

    const [isInviting, setIsInviting] = useState<boolean>(false);
    const [inviteSuccess, setInviteSuccess] = useState<boolean>(false);
    const [inviteError, setInviteError] = useState<string>('')

    const [selected, setSelected] = useState<string[]>([])
    const [companyDirectory, setCompanyDirectory] = useState<DirectoryEntry[]>([])
    const [message, setMessage] = useState<string>('')
    const [lookupMessage, setLookupMessage] = useState<string>('')
    const [isExternalBlocked, setIsExternalBlocked] = useState<boolean>(false)

    const [isOpen, setIsOpen] = useState<boolean>(false)

    useEffect(() => {
        // pull in everyone in the company ...
        fetchWithToken('/company/directory', accessToken!)
            .then((data: DirectoryEntry[]) => {
                console.log(currentUsers);
                setCompanyDirectory(data.filter((x) => !currentUsers.includes(x.user.email)));
                // console.log(data);
            }).catch((err) => {

        })
    }, [project_id])

    const SendInvite = (e: any) => {
        if(selected.length !== 1) {return;}
        e.preventDefault();
        setIsInviting(true)

        postWithToken(
            `/projects/${project_id}/add_user`,
            JSON.stringify({user_email:selected[0], project_id:project_id}),
            accessToken!)
            .then((data) => {
                setInviteSuccess(true)
                setIsInviting(false)
                setMessage(data.message)
                setSelected([])
                onInvite(selected[0])

            })
            .catch((err) => {
                console.log('error', JSON.stringify(err))
                setInviteError(JSON.stringify(err))
                setIsInviting(false)
            })

    }

    const handleChange = (values: string[]) => {
        setSelected(values)
        setLookupMessage('')
        setIsExternalBlocked(false)

        if(values.length > 0){
            setIsEnabled(true)
            const email = values[values.length - 1]
            const isInDirectory = companyDirectory.some(x => x.user.email === email)

            if (!isInDirectory) {
                fetchWithToken(`/qlink/lookup-email/${encodeURIComponent(email)}`, accessToken!)
                    .then((data: any) => {
                        if (data.found && data.company_id === userContext?.company_id) {
                            // same company - directory may be incomplete, allow add
                            setLookupMessage('')
                        } else if (data.found) {
                            setLookupMessage(`${email} belongs to ${data.company_name} and cannot be invited.`)
                            setIsExternalBlocked(true)
                            setIsEnabled(false)
                        } else {
                            setLookupMessage(`${email} is not yet on CStreet. Inviting will add them to your company.`)
                        }
                    })
                    .catch(() => {})
            }
        } else {
            setIsEnabled(false)
        }
    }

    const onDialogOpenChange = () => {
        // setSearchText('')
        // setInviteError('')
    }

    return <Dialog onOpenChange={onDialogOpenChange}>
        <DialogTrigger asChild>
            <Button variant="outline" >Invite Team Member</Button>
        </DialogTrigger>
        <DialogContent className="md:max-w-md">
            <div>
            <DialogTitle className="font-normal !text-[17px] mb-4">Company Directory</DialogTitle>
                <MultiSelectCombobox
                        types={companyDirectory.map(
                            (x) =>  ({value:x.user.email, label:x.user.email }))}
                        open={isOpen}
                        setOpen={setIsOpen}
                        value={selected}
                        onChange={handleChange}
                        width = {"w-[332px]"}
                        creatable={true}
                />

            </div>

            {lookupMessage && (
                <p className={`text-sm ${isExternalBlocked ? 'text-red-600' : 'text-blue-600'}`}>
                    {lookupMessage}
                </p>
            )}

            <Button onClick={SendInvite}
                    disabled={!isEnabled || isExternalBlocked}
            >Invite to Project
            </Button>
            <DialogFooter className="sm:justify-start">
                {isInviting && inviteSuccess && <p>Invite Sent</p>}
                {isInviting && !inviteSuccess && <p>Inviting...</p>}
                 <p>{inviteError}</p>
                <p>{message}</p>
            </DialogFooter>
        </DialogContent>
    </Dialog>
}

